export const BOOSTERS_5 = 'Boosters5';
export const BOOSTERS_15 = 'Boosters15';
export const BOOSTERS_30 = 'Boosters30';
